import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '@app/shared/modules/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SortMenuComponent } from './sort-menu.component';

@NgModule({
  declarations: [SortMenuComponent],
  imports: [CommonModule, TranslateModule.forChild(), MaterialsModule],
  exports: [SortMenuComponent],
})
export class SortMenuModule {}
